import { render, staticRenderFns } from "./FacilityCommission.vue?vue&type=template&id=fc63482e&scoped=true"
import script from "./FacilityCommission.vue?vue&type=script&lang=js"
export * from "./FacilityCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc63482e",
  null
  
)

export default component.exports